import { ButtonTypeTokens, IconTokens, } from '@voltmoney/schema';
import { MARITAL_STATUS, } from './types';
import { api } from '../../../../configs/api';
import { getAppHeader } from '../../../../configs/config';
import { ROUTE } from '../../../../routes';
import SharedPropsService from '../../../../SharedPropsService';
import { nextStepCredStepper } from '../../../../configs/utils';
import AsyncStorage from "@react-native-async-storage/async-storage";
let martialStatus = null;
let fatherFirstName = '';
let fatherLastName = '';
let motherFirstName = '';
let motherLastName = '';
let qualification = null;
export const onChangeInput = async (action, _datastore, { setDatastore }) => {
    switch (action.payload.widgetID) {
        case 'fatherFirstNameInput': {
            fatherFirstName = action.payload.value.trim();
            break;
        }
        case 'fatherLastNameInput': {
            fatherLastName = action.payload.value.trim();
            break;
        }
        case 'motherFirstNameInput': {
            motherFirstName = action.payload.value.trim();
            break;
        }
        case 'motherLastNameInput': {
            motherLastName = action.payload.value.trim();
            break;
        }
    }
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.CO_BORROWER_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
    else {
        await setDatastore(ROUTE.CO_BORROWER_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeOutline,
        });
    }
};
export const onSelect = async (action, _datastore, { setDatastore }) => {
    qualification = action.payload.value;
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.CO_BORROWER_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
};
export const toggleCTA = async (action, _datastore, { setDatastore }) => {
    if (action.payload.value == MARITAL_STATUS.SINGLE) {
        await setDatastore(action.routeId, 'singleRadio', {
            name: IconTokens.RadioCircleFilled,
        });
        await setDatastore(action.routeId, 'marriedRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        martialStatus = MARITAL_STATUS.SINGLE;
    }
    else if (action.payload.value == MARITAL_STATUS.MARRIED) {
        await setDatastore(action.routeId, 'singleRadio', {
            name: IconTokens.RadioCircleNotFilled,
        });
        await setDatastore(action.routeId, 'marriedRadio', {
            name: IconTokens.RadioCircleFilled,
        });
        martialStatus = MARITAL_STATUS.MARRIED;
    }
    if (martialStatus &&
        fatherFirstName &&
        fatherLastName &&
        motherFirstName &&
        motherLastName &&
        qualification) {
        await setDatastore(ROUTE.CO_BORROWER_ADDITIONAL_DETAILS, 'continue', {
            type: ButtonTypeTokens.LargeFilled,
        });
    }
};
export const triggerCTA = async (action, _datastore, { instrumentTrack, navigate, setDatastore, network }) => {
    instrumentTrack("JOINT_HOLDER_ADDITIONAL_INFO_CONFIRM_BUTTON_CLICKED");
    await setDatastore(action.routeId, 'continue', {
        loading: true,
    });
    // @ts-ignore
    const selectedItem = action.payload.selectedItem;
    const user = await SharedPropsService.getUser();
    const applicationId = await AsyncStorage.getItem("application_id") !== null ? await AsyncStorage.getItem("application_id") : user.linkedApplications[0].applicationId;
    const updatedApplicationResponse = await network.get(`${api.borrowerApplication}${applicationId}`, { headers: await getAppHeader() });
    let coBorrowerAccountId;
    if (await AsyncStorage.getItem("application_id") !== null) {
        coBorrowerAccountId = updatedApplicationResponse.data.currentCoBorrowerAccountId;
    }
    else {
        coBorrowerAccountId = user.linkedApplications[0].currentCoBorrowerAccountId;
    }
    const response = await network.post(`${api.submitAdditionalDetailsForCoBorrower}${applicationId}/${coBorrowerAccountId}`, {
        maritalStatus: selectedItem.maritalStatus,
        qualification: selectedItem.qualification,
        fatherFirstName: selectedItem.fatherFirstName,
        fatherLastName: selectedItem.fatherLastName,
        motherFirstName: selectedItem.motherFirstName,
        motherLastName: selectedItem.motherLastName,
    }, {
        headers: await getAppHeader(),
    });
    await setDatastore(action.routeId, 'continue', {
        loading: false,
    });
    user.linkedApplications[0] = response.data.updatedApplicationObj;
    await SharedPropsService.setUser(user);
    const routeObj = await nextStepCredStepper();
    await navigate(routeObj.routeId, routeObj.params);
};
export const GoBackAction = async (action, _datastore, { goBack, navigate }) => {
    await navigate(ROUTE.KYC_STEPPER);
};
export const needHelpAction = async (action, datastore, { navigate }) => {
    await navigate(ROUTE.CONTACT_US_CARD);
};
